<div data-testid="inform-block-wrapper" class="ps-xsmall border rounded-large font-body-1 font-body-medium">
  <div class="medium-type" *ngIf="title">
    <fcom-icon class="icon-medium ms-xsmall-r" [name]="SvgLibraryIcon.INFO" />
    <span class="title">{{ title }}</span>
  </div>
  <ng-content />
</div>
